module.exports = __webpack_public_path__ + "img/t_bg1.2302417a.png";